/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { LegacyButton, Spacer, Text } from '@zapier/design-system';

import Surface from '../../shared/Surface';
import Fields, { Field } from './FormFields/Fields';

const Styles = {
  buttonWrapper: {
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
};

export type FormState = 'initial' | 'readyToSubmit' | 'submitting';

type EmailStepProps = {
  /** An array of fields to render in the form. */
  fields: Array<Field>;
  /** What state the form is in.  */
  formState: FormState;
  /** The callback function to fire when the form is submitted. */
  onSubmit: () => Promise<void>;
};

/**
 * Renders a form with fields and a submit button.
 */
const EmailStep = ({ fields, formState, onSubmit }: EmailStepProps) => {
  return (
    <Surface title="Tell us about your issue">
      <Text margin="0px 0px 20px" type="Body1">
        Please note the apps you are using and what you are hoping to
        accomplish. If you have an example that illustrates your question,
        please provide that as well.
      </Text>
      <Spacer height={10} />
      <Fields fields={fields} />
      <div css={Styles.buttonWrapper}>
        <LegacyButton
          disabled={formState !== 'readyToSubmit'}
          onClick={onSubmit}
        >
          {formState === 'submitting' ? 'Sending...' : 'Send'}
        </LegacyButton>
      </div>
    </Surface>
  );
};

export default EmailStep;
